import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { en, Locale } from '../../locales';
import parentStyles from '../../utils/parentStyles';

const styles = StyleSheet.create({
  signatureContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    paddingTop: 50
  },
  blankLine: {
    borderTop: '1px solid #C2C7D0',
    padding: 4
  },
  text: {
    fontFamily: 'Noto Sans',
    fontSize: 9,
    fontStyle: 'normal',
    fontWeight: 400,
    // No lineHeight: react-pdf takes a number here, and the string 'normal'
    // reaches text layout unconverted, which drops the glyphs entirely - the
    // signature and date labels rendered blank. Omitting it uses the font's
    // own line height, which is what 'normal' was meant to express.
    color: '#4D5165'
  }
});

interface SignatureProps {
  locale?: Locale;
}

const Signature: React.FC<SignatureProps> = ({ locale = en }) => {
  return (
    <View style={{ marginBottom: 24 }} wrap={false}>
      <View style={parentStyles.title}>
        <Text style={parentStyles.titleText}>{locale.signature.signature}</Text>
      </View>
      <View style={styles.signatureContainer}>
        <View style={[styles.blankLine, { width: '68%' }]}>
          <Text style={styles.text}>
            {locale.signature.signature.toUpperCase()}
          </Text>
        </View>
        <View style={[styles.blankLine, { marginLeft: 8, width: '32%' }]}>
          <Text style={styles.text}>{locale.signature.date.toUpperCase()}</Text>
        </View>
      </View>
    </View>
  );
};

export default Signature;
